import { AxiosResponse } from 'axios'
import { IGenericEntityResponse } from 'services/core/entityResponseCore'
import { RequestCDU, RequestGENERIC, RequestREAD } from 'services/Instances'

export const ArchivesNGTService = () => {
  const path: String = 'ParametrizacaoArquivos'
  const path2: String = 'ConfiguracaoParametrizacaoArquivos'

  const create = async (dto: IArchivesParam): Promise<AxiosResponse<any>> =>
    await RequestCDU.post(`${path}/Create`, dto)

  const update = async (dto: IArchivesParam): Promise<AxiosResponse<any>> =>
    await RequestCDU.patch(`${path}/Update`, dto)

  const del = async (idArchive: number): Promise<AxiosResponse<any>> =>
    await RequestCDU.delete(`${path}/Delete`, { params: { id: idArchive } })

  const getAll = async (): Promise<AxiosResponse<IGetArchivesParam>> =>
    await RequestREAD.get(`${path}/GetArquivos`)

  const updateConfiguration = async (
    dto: IConfigurationArchivesParam
  ): Promise<AxiosResponse<any>> =>
    await RequestCDU.patch(`${path2}/Update`, dto)

  const getConfigurationArchives = async (): Promise<
    AxiosResponse<IGetConfigurationArchivesParam>
  > => await RequestREAD.get(`${path}/GetConfiguracaoParametrizacaoArquivos`)

  const getCentroPlantas = async (): Promise<
    AxiosResponse<IGenericEntityResponse<IGetCentroPlanta[]>>
  > => await RequestREAD.get(`CentroPlanta`)

  // ROTAS AGREGADAS
  const aggregatedParametrizacaoArquivos = async (): Promise<
    AxiosResponse<IAggregatedParamsArquivos>
  > => await RequestGENERIC.get('aggregatedParametrizacao_arquivos')

  return {
    aggregatedParametrizacaoArquivos,
    create,
    del,
    getAll,
    getCentroPlantas,
    getConfigurationArchives,
    update,
    updateConfiguration
  }
}

export interface IAggregatedParamsArquivos {
  parametrizacao_arquivos: IGetArchivesParam
  parametrizacao_centroPlanta: ICentroPlantaResponse
  parametrizacao_configuracaoParametrizacaoArquivos: IConfigArquivosResponse
}

export interface IArchivesParam {
  idParametrizacaoCaixa: number
  centroPlantaId: number
  descricaoCaixa: string
}

export interface IConfigurationArchivesParam {
  idConfiguracaoParametrizacaoCaixa: number
  numeroCaixaExterno: number
  quantidadeAnosPrescricao: number
  qtdAnosPrescricao?: number
}

export interface IGetArchivesParam {
  entity: Entity[]
  sucesso: boolean
  mensagem?: any
  detalhe?: any
  tipo?: any
}

export interface ICentroPlantaResponse {
  entity: IGetCentroPlanta[]
  sucesso: boolean
  mensagem?: any
  detalhe?: any
  tipo?: any
}

export interface IConfigArquivosResponse {
  entity: IConfigurationArchivesParam
  sucesso: boolean
  mensagem?: any
  detalhe?: any
  tipo?: any
}

export interface IGetCentroPlanta {
  idCentroPlanta: number
  txDescricao: string
  empresaId: string
}

export interface Entity {
  idParametrizacaoCaixa: number
  centroPlantaId: number
  descricaoCentroPlanta: string
  descricaoCaixa: string
}

export interface EntityConfiguration {
  idConfiguracaoParametrizacaoCaixa: number
  qtdAnosPrescricao: number
  numeroCaixaExterno: number
}

export interface IGetConfigurationArchivesParam {
  sucesso: boolean
  mensagem: string
  detalhe: string
  tipo: string
  entity: EntityConfiguration
}

export interface IConfigurationArchivesParam {
  idConfiguracaoParametrizacaoCaixa: number
  numeroCaixaExterno: number
  quantidadeAnosPrescricao: number
}
